import { render } from "./AddProductForm.vue?vue&type=template&id=2d5bc2c8&scoped=true"
import script from "./AddProductForm.vue?vue&type=script&lang=js"
export * from "./AddProductForm.vue?vue&type=script&lang=js"

import "./AddProductForm.vue?vue&type=style&index=0&id=2d5bc2c8&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5bc2c8"]])

export default __exports__